<template>
  <div id="app">
    <a href="#main-content" class="skip-link">Перейти к содержимому</a>
    <site-header />
    <main id="main-content" class="main">
      <router-view />
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from './components/layout/Header.vue'
import SiteFooter from './components/layout/Footer.vue'
export default {
  name: 'App',
  components: { SiteHeader, SiteFooter },
}
</script>

<style>
@import './assets/css/main.css';

.main {
  padding-top: 72px;
}
</style>
